import PathNames from "@app/const/PathNames"
import { BestBuyHistoryEntry } from "@modules/savings/BestBuyTypes"

const mapNativeLinkToRoute = (link: string) => {
    if (link.endsWith("min-side/Mine-kuponger1") || link.endsWith("/mer/om-menymer")) {
        return {
            pathname: PathNames.BestBuy,
            state: { initialFacet: "Kuponger" },
        } as BestBuyHistoryEntry
    } else if (link.endsWith("varer/Tilbud")) {
        return {
            pathname: PathNames.BestBuy,
            state: { initialFacet: "Tilbud" },
        } as BestBuyHistoryEntry
    } else {
        return PathNames.Home
    }
}

export default mapNativeLinkToRoute
